/*
 * @Author: changcheng
 * @LastEditTime: 2023-07-12 09:58:40
 */
import React, { useEffect, FC, useState, useMemo } from "react";
import { connect } from "react-redux";

import "./index.less";

import Login from "./login"; // 学员登录
import PersonalCenter from "./personalCenter"; // 个人中心
import CarouselModule from "./carousel"; // 轮播
import RecommendCourse from "./recommendCourse"; // 推荐课程
import ProvinceCourse from "./provinceCourse"; // 省级继教课程
import Advertisement from "./advertisement"; // 广告位
import Teacher from "./teacher"; // 名师
import News from "./news"; // 名师
import LinkModule from "./link";
import axios from "@/axios/axios";
import { message, Modal, Button } from "antd"; // 友情链接
const HomePage: FC<any> = ({ history, storeData }) => {
  const {
    userInfo = {
      chargeMode: 1,
    },
  } = storeData;
  // 推荐课程 列表
  const [recommend, setRecommend] = useState<any>([]);
  const [province, setProvince] = useState<any>([]);
  const [showPayWarning, setShowPayWarning] = useState(false);
  const getRecommend = async () => {
    const body = {
      item: {
        itemOrderByType: 1,
      },
      currentPage: 1,
      pageSize: 4,
    };
    const {
      code,
      data: { itemList },
      msg,
    }: any = await axios.post("/shop/front/ce/item/recommend/list", body);
    if (code === 0) {
      setRecommend(itemList);
    } else {
      message.error(msg);
    }
  };

  const getProvince = () => {
    const body = {
      currentPage: 1,
      pageSize: 4,
    };
    axios.post("/shop/front/ce/item/province/list", body).then((res: any) => {
      if (res.code === 0) {
        setProvince(res.data.itemList);
        console.log(res.data.itemList);
      }
    });
  };
  useEffect(() => {
    getRecommend();
    getProvince();
  }, []);
  const handleOk = () => {
    setShowPayWarning(false);
  };

  const handleCancel = () => {
    setShowPayWarning(false);
  };
  useMemo(() => {
    setShowPayWarning(true);
  }, [userInfo]);
  return (
    <div className={"home-main"}>
      <div style={{ display: "flex" }}>
        {userInfo ? <PersonalCenter /> : <Login />}
        <CarouselModule />
      </div>
      <div>
        <Advertisement />
      </div>
      <div style={{ display: "flex" }}>
        <RecommendCourse course={recommend} />
      </div>
      {province.length > 0 && (
        <div style={{ display: "flex" }}>
          <ProvinceCourse course={province} />
        </div>
      )}
      <div style={{ display: "flex" }}>
        <News />
        <Teacher />
      </div>

      <div>
        <LinkModule />
      </div>
      <Modal
        open={showPayWarning && userInfo && userInfo.chargeMode === 2}
        title="提示"
        okText="是"
        cancelText="否"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        mask={true}
        maskClosable={false}
        keyboard={false}
        closable={false}
      >
        <p>
          1.本网站为远程继续医学教育服务平台，学员可根据需求自主选择合适的专业科目课程学习，学习完毕并通过考试后，可申请所选课程学分。
        </p>

        <p>
          2.本网站提供远程继续医学教育培训为有偿服务，按学习时长收取服务费用，标准为：
          {userInfo && userInfo.salePrice}元/学时。
        </p>

        <p>
          3、为进一步规范远程学习，学习过程中系统将自动进行学习签到状态检测，学习前将进行人脸识别认证，请您按要求提前采集人脸识别信息，完成学习签到和人脸识别认证。
        </p>

        <p>4、以上内容已阅读。</p>
        <p
          style={{
            textAlign: "center",
          }}
        >
          <Button type="primary" onClick={handleCancel}>
            同意
          </Button>
        </p>
      </Modal>
    </div>
  );
};

export default connect((state) => state)(HomePage);
